<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama","AltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TabloVerileri: [],
      TabloDetayVerileri: [],
      RiskDegerler:[],
   
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi:[],
      donem_yili:"",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
  },

  methods: {



    Get() {
      this.bugun = new Date();
      //alert(this.bugun);

      this.RiskDegerler = [];
    
                let Filter = "&Donemid="+this.DonemId+"&Gerceklesmedonemid=" + this.AltDonemId;

                if(this.BirimId!=null && this.BirimId!=""){
                    Filter= Filter+"&BirimId="+this.BirimId;
                }
                                 
                this.ActionsFilterGet({ Service: "StrRaporlama/GetRiskKayitFormuRaporu", Page: this.Page, Filter: Filter }).then((res) => {
                  this.RiskDegerler = res.Data;
                 // console.log( this.RiskDegerler)

                 this.RiskDegerler.sort(this.buyuktenKucugeSiralama)
        
                        
                });


    },
    buyuktenKucugeSiralama(a, b) { 
          return b.Etki*b.Olasilik - a.Etki*a.Olasilik;
      },
      renk(Data){
        if(0 < Data < 26){
          return 'yellow'
        }
        if(25 < Data < 65){
          return 'green'
        }
        if(64 < Data){
          return 'red'
        }
      },
        ExcelExport(table, name){  
           
                if (!table.nodeType) table = this.$refs.kayitformu;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
        
  
      }, 




  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Risk Kayıt Formu',
                  'Risk Kayıt Formu',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>



  
    <div ref="kayitformu" class="table-responsive">
      

    <div class="table-responsive">
      <table style="width:100%">
        <tr>
          <td colspan="24" style="text-align: center;">
              <div> <h4> RİSK KAYIT FORMU</h4></div>
          </td>
        </tr>
        <tr><td colspan="24" style="text-align: right;">{{bugun | formatDateTable}}</td></tr>
        <tr><td colspan="24" style="text-align: right;">EK-8</td></tr>
    
    </table>
    <br>

    <table style="border: 1px solid; border-collapse: collapse;  " border="1" 
    class="table  table-md table-bordered border-success mb-0"  >

      <thead style="vertical-align: middle; " class="table-light">
      <tr style="text-align: center; ">
        <td rowspan="2">S.N.</td>
        <td rowspan="2">Risk Türü</td>
        <td rowspan="2">Risk Kaynağı</td>
        <td rowspan="2">İlişkili Olduğu Stratejik Amaç</td>
        <td rowspan="2">Tespit Edilen Risk/Sebebi</td>
        <td colspan="3">RİSKİN</td>
        <td colspan="4">RİSK CEVABI</td>
        <td colspan="4">RİSKİN KONTROLÜ</td>   
        <td rowspan="2" class="dikey_yazi">Riskin Sahibi</td>
        <td rowspan="2" class="dikey_yazi">Yeniden Değerlendirme Tarihi </td>
        <td colspan="3">RİSKİN</td>
        <td colspan="2">RİSKİN DURUMU</td>
        <td rowspan="2">AÇIKLAMA</td>
      </tr>
      <tr >
        <td class="dikey_yazi">Etki</td>
        <td class="dikey_yazi">Olasılık</td>
        <td class="dikey_yazi">Puan</td>
        <td class="dikey_yazi">Kabul Edilebilir</td>
        <td class="dikey_yazi">Kaçınılabilir</td>
        <td class="dikey_yazi">Paylaşılabilir</td>
        <td class="dikey_yazi">Kontrol Edilebilir</td>
        <td class="dikey_yazi">Önleyici Kontrol</td>
        <td class="dikey_yazi">Düzeltici Kontrol</td>
        <td class="dikey_yazi">Yönlendirici Kontrol</td>
        <td class="dikey_yazi">Tespit Edici Kontrol</td>
        <td class="dikey_yazi">Etki</td>
        <td class="dikey_yazi">Olasılığı</td>
        <td class="dikey_yazi">Puan</td>
        <td class="dikey_yazi">Kontrol Altında </td>
        <td class="dikey_yazi">Ek Kontrol İhtiyacı</td>
      </tr>
      </thead>
      <tbody v-for="(Data,index) in RiskDegerler" :key="index">
    <tr >
    <td >{{index+1}}</td>
    <td >{{Data.Risk_turu}}</td>
    <td >{{Data.Risk_kaynagi}}</td>
    <td >{{Data.Stratejik_hedef}}</td>
    <td >{{Data.Tespit_edilen_risk}}</td>
    <td >{{Math.round(Data.Etki)}}</td>
    <td >{{Math.round(Data.Olasilik)}}</td>
    <td class="text-center" :style="{background: renk(Math.round(Math.round(Data.Etki)*Math.round(Data.Olasilik))) } "><span style="color: black">{{Math.round(Math.round(Data.Etki)*Math.round(Data.Olasilik))}}</span></td>
    <td ><span v-if="Data.Riskin_durum_kodu=='1'">E</span></td>
    <td ><span v-if="Data.Riskin_durum_kodu=='3'">E</span></td>
    <td ><span v-if="Data.Riskin_durum_kodu=='2'">E</span></td>
    <td ><span v-if="Data.Riskin_durum_kodu=='4'">E</span></td>
    <td ><span v-if="Data.Onleyici_kontrol!=null">{{Data.Onleyici_kontrol}}</span></td>
    <td ><span v-if="Data.Duzenleyici_kontrol!=null">{{Data.Duzenleyici_kontrol}}</span></td>
    <td ><span v-if="Data.Yonlendirici_kontrol!=null">{{Data.Yonlendirici_kontrol}}</span></td>
    <td ><span v-if="Data.Saptayıcı_kontrol!=null">{{Data.Saptayıcı_kontrol}}</span></td>
    <td >{{Data.Riskinsahibi}}</td>
    <td ></td>
    <td ></td>
    <td ></td>
    <td ></td>
    <td ></td>
    <td ></td>
    <td >{{Data.Aciklama}}</td>

    </tr>
    </tbody>
    </table>
    
    </div>
    
    </div>
  </div>
</template>

<style type="text/css">
.dikey_yazi {
  writing-mode: vertical-rl;

}
</style>
